import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => setIsOpen(!isOpen);
  const closeDrawer = () => setIsOpen(false);

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Meesho", path: "/meesho" },
    { label: "Flipkart", path: "/flipkart" },
    { label: "Amazon", path: "/amazon" },
    { label: "PDF Merge", path: "/pdf-merge" },
    { label: "Create Label", path: "/create-label" },
    { label: "Blog", path: "/blog" },
    { label: "About", path: "/about" },
  ];

  return (
    <>
      {/* Top Navbar */}
      <nav className="bg-toast-blue text-white px-4 py-3 flex items-center justify-between shadow-md">
        <div className="flex items-center gap-2">
          <img src={logo} alt="Drenx Logo" className="h-8 w-auto" />
          <span className="text-lg font-bold">PDFCropEase</span>
        </div>

        {/* Hamburger Menu */}
        <button
          className="md:hidden text-white text-2xl"
          onClick={toggleDrawer}
          aria-label="Toggle Menu"
        >
          ☰
        </button>

        {/* Desktop Menu */}
        <ul className="hidden md:flex gap-5 text-sm font-medium">
          {navItems.map(({ label, path }) => (
            <li key={label}>
              <Link to={path} className="hover:text-toast-red">{label}</Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile Sidebar Drawer */}
      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={closeDrawer}
          ></div>

          <div className="fixed top-0 left-0 w-64 h-full bg-white z-50 shadow-lg transition-transform duration-300 ease-in-out">
            <div className="p-4 border-b flex items-center justify-between">
              <span className="text-lg font-bold text-toast-blue">Menu</span>
              <button className="text-xl" onClick={closeDrawer}>
                ✕
              </button>
            </div>
            <ul className="flex flex-col p-4 gap-1 font-medium text-toast-blue">
              {navItems.map(({ label, path }) => (
                <Link
                  to={path}
                  onClick={closeDrawer}
                  key={label}
                  className="block px-4 py-2 rounded hover:bg-toast-blue/10"
                >
                  {label}
                </Link>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
}
